import Layout from '@/views/layout/Layout'
const accessoriesRouter = {
    path: '/footNav',
    name: 'footNav',
    component: Layout,
    redirect: 'noRedirect',
    children: [
        // vipServices路由
        // {
        //     path: 'vipServices',
        //     name: 'vipServices',
        //     component: () => import('@/views/footNav/vipServices'),
        // },
        // 关于我们路由
        {
            path: 'aboutUs',
            name: 'aboutUs',
            component: () => import('@/views/footNav/aboutUs'),
        },
        // 联系方式路由
        {
            path: 'telphone',
            name: 'telphone',
            component: () => import('@/views/footNav/telphone'),
        },
        // 注册指南路由
        {
            path: 'registGuide',
            name: 'registGuide',
            component: () => import('@/views/footNav/registGuide'),
        },
        // 法律声明路由
        {
            path: 'legalStatement',
            name: 'legalStatement',
            component: () => import('@/views/footNav/legalStatement'),
        },
        // 广告服务路由
        {
            path: 'adverService',
            name: 'adverService',
            component: () => import('@/views/footNav/adverService'),
        }
    ]
}
export default accessoriesRouter


// WEBPACK FOOTER //
// ./src/router/modules/footNav.js